import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HUB_API_SETTINGS_TOKEN } from '../../hub-api-settings-token';
import { HubApiSettingsService } from '../../hub-api-settings.service';
import { InspectionReportInput } from '../model/query/inspection-report-input';
import { DefectReportInput } from '../model/query/defect-report-input';
import { Query } from '../model/query/query';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Generated service for communicating with the InspectionReport API endpoint.
@Injectable()
export class InspectionReportEndpointService {

  constructor(
    private http: HttpClient,
    private settingsService: HubApiSettingsService,
  ) {}

  GetInspectionCompletedReport(inspectionCompletedInput: InspectionReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: inspectionCompletedInput,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Inspection/completed',
      options);
  }

  GetInspectionStatusReport(inspectionStatusInput: InspectionReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: inspectionStatusInput,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Inspection/status',
      options);
  }

  GetInspectionHistoryReport(inspectionHistoryInput: InspectionReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: inspectionHistoryInput,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Inspection/history',
      options);
  }

  GetUnsafeScaffoldReport(unsafeScaffoldInput: InspectionReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: unsafeScaffoldInput,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Inspection/unsafe',
      options);
  }

  GetUnsafeScaffoldReportForDownload(relatedInspectionId: string): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'GET',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Inspection/unsafe/download?relatedInspectionId=' + relatedInspectionId,
      options);
  }

  GetRemedialReport(remedialActionInput: InspectionReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: remedialActionInput,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Inspection/remedial',
      options);
  }

  GetRemedialReportForDownload(relatedInspectionId: string): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'GET',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Inspection/remedial/download?relatedInspectionId=' + relatedInspectionId,
      options);
  }

  SiteInspectionReport(siteInspectionInput: InspectionReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: siteInspectionInput,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Inspection/site-inspection',
      options);
  }

  GetSiteInspectionReportForDownload(relatedInspectionId: string): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'GET',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Inspection/site-inspection/download?relatedInspectionId=' + relatedInspectionId,
      options);
  }

  InspectionsDueReport(siteInspectionInput: InspectionReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: siteInspectionInput,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Inspection/inspections-due',
      options);
  }

  DefectTypesReport(reportInput: DefectReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: reportInput,
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Inspection/defect-types',
      options);
  }

  DefectTypesExport(reportInput: DefectReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: reportInput,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Inspection/defect-types/export',
      options);
  }
}
